module.exports = __webpack_public_path__ + "static/media/start.f4b3eee7.svg";